export default "__VITE_ASSET__120e6db9__"